import { render, staticRenderFns } from "./login1.vue?vue&type=template&id=48d3c590&scoped=true&"
import script from "./login1.vue?vue&type=script&lang=js&"
export * from "./login1.vue?vue&type=script&lang=js&"
import style0 from "./login1.vue?vue&type=style&index=0&id=48d3c590&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d3c590",
  null
  
)

export default component.exports